<template>
  <div class="pageContent pageFooterPage useCoupons">
    <LoadingModal />
    <div>
      <div class="pageFlexBetween header">
        <div class="word" style="color: rgb(255, 255, 255)">
          <span>我的卡券</span>
        </div>
        <i class="iconfont iconCancelcontrol" @click="close"></i>
      </div>
      <KImg class="logo" :src="logo" />
      <div class="pageCard content">
        <div class="pageFlexBetween title">
          <p class="pageFontWeight">{{ $getItem("config").name }}</p>
          <span>{{ coupon.couponsNum }}</span>
        </div>
        <div class="pageFlexColumn detail">
          <p class="notice">
            本服务由[{{ thirdPartyName }}] 提供，请向门店工作人员出示服务二维码
          </p>
          <p>{{ coupon.couponsProductName }}</p>
          <span>有效期至 2024-01-11</span>
          <div class="qrcode" ref="qrCode"></div>
          <p class="code">{{ ticketNumber }}</p>
        </div>
        <div class="pageFlexCenter more" @click="showStoreInfo">
          <div class="pageFlex word" style="color: var(--depGreenColor)">
            <span data-v-5150df18="">点击查看可用网点</span
            ><i class="iconfont right iconbackwardcyclyo"></i>
          </div>
        </div>
        <div class="tip">
          <!-- <p><font class="remark">适用城市：</font><span></span></p> -->
          <p>
            <font class="remark">使用限制：</font
            ><span>法定假日不可用，如需使用请与网点沟通。</span>
          </p>
        </div>
        <div class="pageFlexCenter warning">
          核销过程中请勿关闭此页面，请等待核销成功
        </div>
      </div>
      <Tips>
        <div slot="content">
          <ul
            style="
              list-style: disc;
              color: #fff;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <span
                >该页面由公众号“{{
                  $getItem("config") != undefined
                    ? $getItem("config").name
                    : ""
                }}”提供</span
              >
            </li>
            <li style="list-style: disc">
              <span>二维码仅用于网点核销使用，不做他用</span>
            </li>
          </ul>
        </div>
      </Tips>
    </div>
  </div>
</template>

<script>
import { queryCoupon, getCouponVerifyCode, getStoreList } from "api/offLine";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      logo: require("@/assets/" + this.$getItem("config").logo + ".png"),
      imgUrl: "",
      coupon: [],
      ticketNumber: "",
      thirdPartyName: "",
    };
  },
  created() {
    this.$setBodyBackground(1, "var(--depBlueColor)");
    this.coupon = JSON.parse(this.$route.query.couponInfo);
  },
  beforeDestroy() {
    this.$setBodyBackground(2);
  },
  mounted() {
    this.getVerifyCode();
    this.queryCoupon();
    this.$store.commit("setPageLoading", false);
  },
  destroyed() {
    window.clearInterval(this.timer);
  },
  methods: {
    getVerifyCode() {
      getCouponVerifyCode(
        this.coupon.couponsId,
        this.coupon.couponsCityCode,
        this.coupon.couponsShopId
      ).then((res) => {
        if (res.status == 200) {
          this.ticketNumber = res.data.ticketNumber;
          this.thirdPartyName = res.data.thirdPartyName;
          this.creatQrCode(this.ticketNumber);
          this.queryCouponInfo();
        } else {
          this.$dialog({
            title: "",
            message: res.message,
          }).then(() => {
            this.$push({
              path: "/coupons",
            });
          });
        }
      });
    },
    creatQrCode(data) {
      new QRCode(this.$refs.qrCode, {
        text: data, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    queryCouponInfo() {
      this.timer = window.setInterval(() => {
        setTimeout(() => {
          this.queryCoupon();
        }, 0);
      }, 3000);
    },
    queryCoupon() {
      queryCoupon(this.coupon.couponsId).then((res) => {
        if (res.status == 200) {
          if (res.data.couponsStatus === 4) {
            this.$successSync("核销成功", () => {
              this.$push({
                path: "/orders?type=-1",
              });
            });
          }
        }
      });
    },
    showStoreInfo() {
      getStoreList(
        this.coupon.couponsLongitude,
        this.coupon.couponsLatitude
      ).then((res) => {
        if (res.status == 200) {
          if (res.data.length <= 0) {
            this.$error("查询门店失败，请稍后再试");
          }
          res.data.forEach((item) => {
            if (item.shopId === this.coupon.couponsShopId) {
              this.$store.commit("setStoreInfo", item);
              this.$push({
                path: "/showStore",
              });
            }
          });
        } else {
          this.$error("查询门店失败，请稍后再试");
        }
      });
    },
    close() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.useCoupons {
  // position: fixed;
  .header {
    height: 46px;
    .iconCancelcontrol {
      font-size: 20px;
      color: #fff;
    }
  }
  .logo {
    width: 66px;
    height: 66px;
    margin: -20px auto 0;
    border-radius: 50%;
  }
  .content {
    margin-top: -30px;
    margin-bottom: 23px;
    padding: 10px 20px;
    font-size: var(--pFont);
    .title {
      font-size: var(--titleFont);
      color: var(--depBlueColor);
      margin: 0 -20px;
      padding: 4px 20px 14px;
      border-bottom: 1px solid var(--lineColor);
      position: relative;
      &::before {
        left: -12px;
        content: "";
        position: absolute;
        bottom: -12px;
        width: 22px;
        height: 22px;
        background: var(--depBlueColor);
        border-radius: 50%;
      }
      &::after {
        right: -12px;
        content: "";
        position: absolute;
        bottom: -12px;
        width: 22px;
        height: 22px;
        background: var(--depBlueColor);
        border-radius: 50%;
      }
    }
    .detail {
      margin-top: 5px;
      .notice {
        border: 1px solid #e2e2dd;
        padding: 5px 10px;
        font-size: 14px;
        color: #99954e;
        background: #fcfae3;
      }
      .qrcode {
        margin-top: 10px;
        height: 200px;
        width: 200px;
      }
      .code {
        font-size: 20px;
      }
      p {
        font-size: var(--mBigFont);
        margin: 10px;
      }
      span {
        color: var(--hidColor);
        font-size: var(--pFont);
        margin-top: -4px;
        display: inline-block;
      }
    }
    .more {
      margin: 20px -20px;
      height: 60px;
      color: var(--depGreenColor);
      font-size: var(--mBigFont);
      border: 1px solid #ddd;
      border-left: none;
      border-right: none;
      background: #edf8ee;
    }
    .tip {
      color: var(--depHidColor);
      margin-bottom: 30px;
      .remark {
        width: 80px;
      }
      p {
        display: flex;
      }
      span {
        width: 76%;
        display: inline-block;
        vertical-align: top;
      }
    }
    .warning {
      background: #ffffcd;
      color: #b8741a;
      height: 32px;
      margin: -10px -20px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
}
</style>